import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function DeleteModal({
  // Modal state
  isOpen,
  onClose,
  onConfirm,
  
  // Customizable text
  title = "Delete Vehicle!",
  message = "Are you sure you want to delete this vehicle? This action cannot be undone.",
  cancelButtonText = "Cancel",
  confirmButtonText = "Delete",
  
  // Optional styling overrides
  titleColor = "#EE3B2B",
  confirmButtonColor = "#EE3B2B",
  confirmButtonHoverColor = "#D03A28",
  width = "450px",
  minHeight = "200px"
}) {
  const {t}=useTranslation()
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        style: {
          backgroundColor: 'white',
          width: '100%',
          maxWidth: width,
          minHeight: minHeight,
          borderRadius: '8px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      <DialogTitle
        style={{
          fontWeight: 'bold',
          fontSize: '24px',
          color: titleColor,
          textAlign: 'left',
          padding: '20px 20px',
        }}
      >
        {t(title)}
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          style={{
            color: '#333',
            fontSize: '18px',
            fontWeight: '400',
            textAlign: 'left',
            marginBottom: '10px',
            padding: "0px 0px"
          }}
        >
          {message}
        </DialogContentText>
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: 'center',
          paddingBottom: '20px',
        }}
      >
        <button
          onClick={onClose}
          style={{
            padding: '12px 30px',
            backgroundColor: '#F2F2F3',
            color: '#333',
            fontWeight: '600',
            border: 'none',
            borderRadius: '6px',
            textTransform: 'none',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
            marginRight: '20px',
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#E0E0E0'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#F2F2F3'}
        >
          {t(cancelButtonText)}
        </button>

        <button
          onClick={onConfirm}
          style={{
            padding: '12px 30px',
            backgroundColor: confirmButtonColor,
            color: '#fff',
            fontWeight: '600',
            border: 'none',
            borderRadius: '6px',
            textTransform: 'none',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = confirmButtonHoverColor}
          onMouseLeave={(e) => e.target.style.backgroundColor = confirmButtonColor}
        >
          {t(confirmButtonText)}
        </button>
      </DialogActions>
    </Dialog>
  );
}